<template>
    <div>
        <div class="container-fluid mt-5 mb-6 mt-lg-6 mb-lg-9">
            <div class="row justify-content-center">
                <div class="col-xl-6 order-xl-1">
                    <card shadow type="secondary" v-if="user">
                        <div slot="header" class="bg-white border-0">
                            <div class="row align-items-center">
                                <div class="col-12">
                                    <h3 class="mb-0">{{ $t('confirm_phone_number') }}</h3>
                                </div>
                            </div>
                        </div>
                        <template>
                            <div class="row justify-content-center">
                                <SmsConfirm/>
                            </div>
                        </template>
                    </card>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import userApi from "../../../data/UserApi";
    import SmsConfirm from "../../Auth/SmsConfirm";

    export default {
        name: 'ConfirmPhone',
        components: {SmsConfirm},
        data() {
            return {
                user: null,
                profile: null,
                loading: false,
            }
        },

        computed: {},

        mounted() {
            this.loading = true
            userApi.fetchProfile()
                .then(async response => {
                    this.loading = false
                    this.user = response
                    this.profile = Object.assign({}, this.user.profile)
                })
                .catch(error => {
                    let data = (error && error.response) ? error.response.data : {}
                    this.error = this.pretty(data)
                    this.loading = false
                })
        },

        methods: {}
    };
</script>
<style></style>
